import { render, staticRenderFns } from "./specification.vue?vue&type=template&id=c25bec40&scoped=true&"
import script from "./specification.vue?vue&type=script&lang=ts&"
export * from "./specification.vue?vue&type=script&lang=ts&"
import style0 from "./specification.vue?vue&type=style&index=0&id=c25bec40&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c25bec40",
  null
  
)

export default component.exports